<template lang="html">
  <div
    class="signatures"
    v-if="
      !(
        order.orderState == 10 ||
        (order.refundState == 10 && order.orderState == 50)
      ) &&
      codeList.length > 0 &&
      (channelType != 4 || (channelType == 4 && groupStaus == 2))
    "
  >
    <!--(不是待支付10 已取消50) 并且 总次数大于0 并且（不是团购 或者 团购必须是团成功的状态）才展示二维码核销的
        channelType //1.正常下单2.一元购3.抢购4.团购5.积分
        smallGroupStatus //小团状态(1-参团中 2团成功 3 团失败 )-->
    <div class="signatures-wrapper">
      <div class="title">
        <p>核销</p>
        <span class="titleTip">核销完成后本平台将向商家支付款项</span>
      </div>
      <div class="number">
        <p>
          待核销<span class="count countred">{{ newCodes.length }}次</span>
        </p>
        <p>
          已核销<span class="count"
            >{{ codeList.length - newCodes.length }}次</span
          >
        </p>
        <div>
          <div
            class="iconTip"
            v-if="codeList.length - newCodes.length > 0"
            @click="showScan"
          >
            <div class="iconTipToolTip" v-if="showScanItem">
              <i class="iconfont icon-jiantou iconTipToolImg"></i>
              <div class="iconTipToolP">
                <p
                  v-if="+item.barcodeState === 1"
                  v-for="(item, index) in oldCodes"
                >
                  <span class="dot">{{
                    $$dateFormat(item.writeoffTime, 'YY.MM.DD hh:mm:ss')
                  }}</span
                  ><span>完成第{{ index + 1 }}次核销</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--订单待服务 退单是未退单或者是退单失败 都展示核销码-->
      <div
        class="qrcodeContainer"
        v-show="
          order.orderState == 20 &&
          (order.refundState == 10 || order.refundState == 40)
        "
      >
        <div
          class="qrcodeItem qrcodeBusiness"
          @click="showCode(showingCode.barcode)"
        >
          <div class="qrcodeBusinessL">
            二维码核销<span class="qrcodeBusinessScan">商家扫码</span
            ><img
              class="scanImg"
              src="../../assets/images/order/icon-scan.png"
            />
          </div>
        </div>
        <div
          class="qrcodeItem qrcodeUser"
          @click="useCode(showingCode.barcode)"
        >
          <div>自助核销</div>
        </div>
      </div>
    </div>
    <codeModal :visiable="codeModalVisiable" title="出示二维码给商家核销">
      <div class="dialog-qrcode">
        <div class="qrcode-box" ref="qrCode"></div>
        <p class="code">{{ showingCode.barcode }}</p>
        <p class="desc">
          <span class="tip">核销提示:</span
          >请确认消费验证码，一旦出示给商家核销，即表明您同意本平台向商家支付全额款项，并后续产生的一切纠纷及/或损失均由您自行承担，与本平台无关
        </p>
        <div class="cancel" @click="codeModalCancel">取消</div>
      </div>
    </codeModal>
    <codeModal :visiable="selfModalVisiable" title="自助核销">
      <div class="item-cells dialog-useCode">
        <p class="summary">
          <span class="tip">确认提示:</span
          >一旦确认完成，即表明您同意本平台向商家支付全额款项，并后续产生的一切纠纷及/或损失均由您自行承担，与本平台无关
        </p>
        <div class="button">
          <div class="selfcancel" @click="selfModalCalcel">取消</div>
          <div class="selfok" @click="postCode(showingCode.barcode)">
            确认完成
          </div>
        </div>
      </div>
    </codeModal>
  </div>
</template>
<script>
// import JsBarcode from 'jsbarcode'
import { mapState } from 'vuex'
import { Swipe, SwipeItem } from 'mint-ui'
import { Msgbox } from 'kf-component-vue'
import Qr from '@/plugins/qrCode'
import codeModal from '@/components/newOrder/codeModal'
import { pushNrNs } from '@/plugins/jump'

let interval = ''
export default {
  inject: ['reload'],
  props: {
    codeList: {
      type: Array,
      default() {
        return []
      }
    },
    channelType: {
      // 订单类型
      type: Number,
      default: 1
    },
    groupStaus: {
      // 拼团状态
      type: Number,
      default: 1
    }
  },
  destroyed() {
    interval && window.clearInterval(interval)
  },
  data() {
    return {
      showingCode: {}, //当前展示的核销码
      needUpdate: true,
      showScanItem: false,
      codeModalVisiable: false,
      selfModalVisiable: false
    }
  },
  watch: {
    showingCode(val) {
      //当前展示的核销-码变更
      if (val && val.barcode && val.barcodeState != 1) {
        this.$nextTick(() => {
          const qr = new Qr(this.$refs.qrCode, {
            text: val.barcode,
            width: 120,
            height: 120,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: Qr.CorrectLevel.H
          })
        })
      }
    },
    order(o) {
      // showingCode初始值是{} ？
      // store请求后，监测到order变化后，computed newCodes 给this.showingCode.barcode 赋值
      // 过滤出barcode与当前this.showingCode.barcode相同的核销码JSON对象信息？
      // 再触发watch showingCode 的处理？
      const codeList = o.code_list || []
      const new_code_show =
        codeList.filter(ele => ele.barcode === this.showingCode.barcode)[0] ||
        {}
      this.showingCode = new_code_show
    }
  },
  methods: {
    showScan() {
      this.showScanItem = !this.showScanItem
    },
    isComfirmWork() {
      let _v = []
      // 订单是签约月嫂 判断是否确认上户 如果用户已经确认上户就允许核销 2 如未确认上户就提示 请先完成上户确认再核销
      if (
        this.order.level4CategoryId == '10112210' &&
        this.order.barcodeList &&
        this.order.barcodeList.length > 0
      ) {
        let v = this.order.barcodeList
        _v = v.filter(item => {
          return item.workState == 40 // 核销码里面40 已经确认上户
        })
      }
      return _v.length > 0 ? true : false
    },
    async useCode(itemCode) {
      let _isComfirmWork = !this.isComfirmWork()
      if (this.order.level4CategoryId == '10112210' && _isComfirmWork) {
        this.$$toast('请先完成上户确认再核销')
      } else {
        this.selfModalVisiable = true
      }
    },
    async postCode(itemCode) {
      this.selfModalVisiable = false
      this.$emit('barCode', true)
      const serveCode = this.order.workerUid
      const uid = this.$$cookie('uid')
      const skey = this.$$cookie('skey')
      const param = {
        uid,
        skey,
        vorderId: this.order.orderId,
        barcode: itemCode
      }
      const code_res = await this.$store.dispatch('useCode', param)
      this.$emit('barCode', false)
      if (code_res.code === '1') {
        this.$$toast('核销成功')
        // this.$emit('barCode', false)
        this.showingCode.barcodeState = 1
        this.showingCode.barcodeUseEndTime = new Date().getTime()
        if (this.newCodes.length === 0) {
          // 码全部核销完毕
          // this.$emit('barCode', true)
          // 重新调用详情接口
          const res = await this.$store.dispatch('getOrderDetail', {
            uid: this.$$cookie('uid'),
            skey: this.$$cookie('skey'),
            orderCode: this.order.orderId
          })
          if (res) {
            // this.$emit('barCode', false)
            setTimeout(() => {
              pushNrNs({
                // 新写评价入口
                name: 'evaluate',
                query: {
                  orderCode: this.order.orderId,
                  ht: 'add'
                }
              })
            }, 300)
          }
        } else {
          this.reload()
        }
      } else if (code_res.code === '4') {
        this.$$login()
        // this.$emit('barCode', false)
      } else {
        this.$$toast(code_res.msg)
        // this.$emit('barCode', false)
      }
    },
    codeModalCancel() {
      this.codeModalVisiable = false
      clearInterval(interval)
    },
    selfModalCalcel() {
      this.selfModalVisiable = false
    },
    showCode(code) {
      let _isComfirmWork = !this.isComfirmWork()
      if (this.order.level4CategoryId == '10112210' && _isComfirmWork) {
        this.$$toast('请先完成上户确认再核销')
      } else {
        this.codeModalVisiable = true
        let order = this.order.orderId
        this.isComfirmCode(code, order)
      }
    },
    isComfirmCode(code, order) {
      let count = 0
      let isFetch = true
      interval = setInterval(async () => {
        if (count == 36) {
          clearInterval(interval)
          this.codeModalVisiable = false
        } else {
          count++
          const param = {
            orderId: order,
            barcode: code,
            uid: this.$$cookie('uid'),
            skey: this.$$cookie('skey')
          }
          if (isFetch) {
            isFetch = false
            const code_res = await this.$store.dispatch(
              'queryBarcodeStatus',
              param
            )
            if (code_res) {
              isFetch = true
              if (
                code_res.code == 1 &&
                code_res.data &&
                +code_res.data.barcodeState == 1
              ) {
                // 重新调用详情接口
                clearInterval(interval)
                const res = await this.$store.dispatch('getOrderDetail', {
                  uid: this.$$cookie('uid'),
                  skey: this.$$cookie('skey'),
                  orderCode: this.order.orderId
                })
                this.codeModalVisiable = false
                if (this.newCodes.length === 0) {
                  pushNrNs({
                    // 新写评价入口
                    name: 'evaluate',
                    query: {
                      orderCode: order,
                      ht: 'add'
                    }
                  })
                }
                // location.href = location.href
              }
            }
          }
        }
      }, 5000)
    }
  },
  computed: {
    ...mapState(['order']),
    oldCodes() {
      // 已核销的码信息
      const olds = this.codeList.filter(ele => ele.barcodeState === 1)
      return olds
    },
    // 未核销或退款驳回
    newCodes() {
      let code = {}
      const news = this.codeList.filter(ele => ele.barcodeState === 0)
      // 已过期
      const overTimeCodes =
        this.codeList.filter(ele => ele.barcodeState === 3) || []
      if (news[0]) {
        code = news[0] || {}
      } else if (overTimeCodes[0]) {
        code = overTimeCodes[0] || {}
      } else {
        code = this.codeList[0] || {}
      }
      if (this.needUpdate) {
        this.showingCode = code
        this.needUpdate = false
      }
      return news
    }
  },
  components: {
    Swipe,
    SwipeItem,
    Msgbox,
    codeModal
  }
}
</script>
<style lang="scss">
.kfcv-msgbox .kfcv-msgbox-core {
  width: 5.6rem !important;
}
.kfcv-msgbox .kfcv-msgbox-content {
  font-size: 0.28rem;
  color: #666666;
  padding: 0.46rem 0.2rem 0.3rem !important;
}
</style>
<style lang="scss" scoped>
@import '../../assets/css/mixin';

.signatures {
  margin: rem(24px) rem(24px) rem(20px);
  border-radius: rem(16px);
  background-color: #ffffff;
  line-height: 1.2;
  font-size: rem(28px);

  .expiry-date {
    margin-top: rem(10px);
    color: #999;
    font-size: rem(24px);
  }
  .signatures-wrapper {
    padding: rem(40px) rem(24px) rem(18px);
  }

  .promotion {
    > a,
    img {
      width: 100%;
      height: rem(300px);
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: rem(30px);
    font-size: rem(32px);
    font-weight: bold;
    color: #000000;

    .titleTip {
      font-size: rem(22px);
      font-weight: normal;
      color: #999999;
    }
  }

  .number {
    display: flex;
    align-items: center;
    font-size: rem(26px);
    color: #666666;
    line-height: rem(32px);
    font-weight: normal;
    padding-bottom: rem(20px);
    > p:first-child {
      margin-right: rem(48px);
    }

    .count {
      font-weight: bold;
      margin-left: rem(12px);
      color: #000000;
    }
    .countred {
      color: #ff395e;
    }
    .iconTip {
      position: relative;
      margin: 0 0 0 rem(12px);
      width: rem(24px);
      height: rem(24px);
      background: url('../../assets/images/order/icon-tip.png') center center;
      background-size: rem(24px) rem(24px);

      // .clearfix {
      //     clear: box;
      // }

      .iconTipToolTip {
        width: rem(470px);
        border-radius: rem(6px);
        position: relative;
        top: rem(24px);
        left: -2.35rem;
        z-index: 99;
        font-size: rem(24px);
        color: #ff6010;
        line-height: rem(30px);

        .iconTipToolImg {
          display: flex;
          align-items: center;
          justify-content: center;
          // color: rgba(254,231,160,1);
          color: #fff9ed;
          transform: rotate(180deg);
          position: absolute;
          top: 0;
          left: 2.35rem;
        }

        .iconTipToolP {
          width: rem(470px);
          position: absolute;
          display: inline-block;
          top: rem(18px);
          // background: rgba(254,231,160, 0.9);
          background: #fff9ed;
          border-radius: rem(12px);
          padding: rem(24px);
          @include border(all, #fff1d4, 1px, 6px, solid);
          & > p {
            display: flex;
            justify-content: space-between;
            margin-bottom: rem(12px);

            .dot {
              &::before {
                display: inline-block;
                content: '';
                background: #ff6010;
                width: rem(4px);
                height: rem(4px);
                border-radius: 50%;
                vertical-align: middle;
                margin-right: rem(12px);
              }
            }
          }
        }
      }
    }
  }

  .qrcodeContainer {
    .qrcodeItem {
      height: rem(88px);
      font-size: rem(26px);
      color: #000000;
      @include border(top, #f2f2f2);
      line-height: rem(88px);
      display: flex;
      align-items: center;
      justify-content: space-between;

      &::after {
        content: ' ';
        width: rem(20px);
        height: rem(20px);
        background: url('../../assets/images/order/icon-arr.png') center center;
        background-size: contain;
      }
    }
    .qrcodeBusiness {
      .qrcodeBusinessL {
        flex: 1;
      }
      .scanImg {
        float: right;
        width: rem(43px);
        height: rem(43px);
        margin: rem(22px) rem(24px) 0;
      }
    }

    .qrcodeBusinessScan {
      height: rem(28px);
      margin-left: rem(12px);
      padding-left: rem(12px);
      font-size: rem(22px);
      color: #999999;
      border-left: 1px solid #cccccc;
    }
  }
}
.barcode {
  height: rem(320px);
  svg {
    width: rem(500px);
  }
  .hasUse {
    // color: #666;
  }
  .code-wrapper {
    display: flex;
    align-items: center;
    padding: rem(20px) 0;

    .code {
      flex: 1;
      position: relative;
      width: rem(410px);
      height: 55px;
      padding-right: rem(30px);
    }
  }

  .action {
    button {
      padding: rem(10px) rem(15px);
      @include border(all, #4f4f4f);
    }
    > span {
      font-size: rem(24px);
      padding: rem(10px) rem(15px);
      color: #d0d0d0;
      @include border(all, #dcdcdc);
    }
  }
}
#dialog_content,
#qrcode {
  display: none;
}
.dialog-useCode {
  line-height: 1.5;

  .summary {
    text-align: left;
    font-size: rem(28px);
    color: #666666;
    padding: rem(20px) rem(30px) rem(34px);
  }
  .tip {
    display: inline-block;
    // background: #FF6EA2;
    // border-radius: rem(4px);
    // color: #fff;
    color: #000;
    line-height: rem(40px);
    height: rem(34px);
    font-size: rem(28px);
    font-weight: bold;
    text-align: center;
    margin-right: rem(12px);
    // padding: 0 rem(8px);
  }
  .item-cell {
    margin: rem(25px) 0;
  }
  .item-cell-bd {
    white-space: nowrap;
  }
  input {
    margin-left: rem(20px);
    border-bottom: 1px solid #eee;
  }

  .button {
    display: flex;
    align-items: center;
    // justify-content: center;
    @include border(top, #dcdcdc);
    height: rem(88px);

    & > div {
      flex: 1;
      text-align: center;
      background: #ffffff;
      font-size: rem(32px);
      color: #121212;
      line-height: rem(88px);
    }

    .selfok {
      @include border(left, #dcdcdc);
      color: #ff397e;
    }
  }
}
.dialog-qrcode {
  // padding: rem(30px) 0;
  text-align: center;
  .qrcode-box {
    width: rem(360px);
    height: rem(360px);
    margin: 0 auto;
    margin-bottom: rem(20px);
    margin-top: rem(28px);

    img {
      width: 100%;
      height: 100%;
    }
  }
  .code {
    font-size: rem(42px);
    margin-bottom: rem(10px);
  }
  .desc {
    font-size: rem(26px);
    color: #333333;
    text-align: left;
    padding: rem(20px) rem(30px);
    line-height: rem(40px);
  }
  .tip {
    display: inline-block;
    // background: #FF6EA2;
    // border-radius: rem(4px);
    // color: #fff;
    color: #000000;
    font-weight: bold;
    line-height: rem(40px);
    height: rem(40px);
    font-size: rem(26px);
    text-align: center;
    margin-right: rem(12px);
    // padding: 0 rem(8px);
  }
  .cancel {
    @include border(top, #f2f2f2);
    height: rem(88px);
    line-height: rem(88px);
    font-size: rem(32px);
    color: #121212;
    text-align: center;
  }
}
.qrcode-container {
  position: relative;
  padding-top: rem(15px);
  .semi-circle {
    &::before,
    &::after {
      content: '';
      position: absolute;
      bottom: rem(94px);
      width: 10px;
      height: 10px;
      line-height: 10px;
      text-align: center;
      background-color: #fff;
      border: 1px solid #e7e7e7;
      z-index: 5;
    }
    &::before {
      left: rem(-6px);
      border-radius: 10px 10px 0 0;
      height: 5px;
      transform: rotate(90deg);
      border-bottom-color: #fff;
    }
    &::after {
      right: rem(-6px);
      border-radius: 10px 10px 0 0;
      height: 5px;
      transform: rotate(-90deg);
      border-bottom-color: #fff;
    }
  }
  .code-main {
    padding: rem(25px);
    @include border(all, #e7e7e7, 1px, 2px);
  }
  .code-detail {
    display: flex;
    align-items: center;
    margin-bottom: rem(20px);

    .number-show {
      flex: 1;

      > p:first-child {
        font-size: rem(42px);
      }
      > p:nth-child(2) {
        color: #999;
        margin-top: rem(10px);
        font-size: rem(24px);
        span {
          margin-right: rem(20px);
        }
      }
    }
    .qrcode-trigger {
      @include border(left, #e7e7e7);
      text-align: center;
      padding-left: rem(30px);

      .qr-small {
        font-size: rem(45px);
        color: #444;
        .icon-erweima {
          font-size: inherit;
        }
      }
      > p {
        margin-top: rem(10px);
        color: #999;
        font-size: rem(24px);
      }
    }
  }
  .code-state {
    display: flex;
    align-items: center;
    padding-top: rem(25px);
    @include border(top, #e7e7e7, 1px, 0, dashed);
    font-size: rem(24px);

    .state-desc {
      flex: 1;
      color: #999;
      height: rem(50px);
      line-height: rem(50px);
      em {
        font-size: rem(28px);
        color: #666;
        margin-right: rem(10px);
      }
    }
    .usecode-trigger {
      button,
      span {
        display: inline-block;
        width: rem(140px);
        height: rem(50px);
        line-height: rem(50px);
        text-align: center;
        @include border(all, #505050, 1px, 2px);
      }
      span {
        color: #999;
        &::before {
          border-color: #ddd;
        }
      }
    }
  }
}
.codeQrCode {
}
</style>
<style lang="scss">
.qrcode-box {
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
